import update from 'immutability-helper';
import constants from 'constants';

const {
  ADD_CALENDAR_BOOKING,
  ADD_BOOKING_HOLIDAYS,
  ADD_CALENDAR_BOOKINGS,
  ADD_ADMIN_CALENDAR_BOOKINGS,
  PUT_ADMIN_CALENDAR_BOOKING,
  ADD_CALENDAR_EDIT_BOOKING,
  ADD_CALENDAR_SPONSOR_BOOKINGS
} = constants;

const bookings = (bookings = {
  adminBooking: {
    values: [],
    page: 0,
    pages: 0,
    query: {}
  },
  editBooking: {},
  sponsorBookings: {},
  holidays: [],
  values: {}
}, {
  type,
  payload
}) => {
  switch (type) {
    case ADD_CALENDAR_BOOKING:
      return {
        ...bookings,
        values: update(bookings.values, {
          $push: [payload]
        })
      }
    case ADD_CALENDAR_BOOKINGS:
      return {
        ...bookings,
        ...{
          values: payload
        }
      }
    case ADD_BOOKING_HOLIDAYS:
      return {
        ...bookings,
        holidays: payload
      }
    case ADD_CALENDAR_SPONSOR_BOOKINGS:
      return {
        ...bookings,
        ...{
          sponsorBookings: payload
        }
      }
    case ADD_ADMIN_CALENDAR_BOOKINGS:
      return {
        ...bookings,
        ...{
          adminBooking: payload
        }
      }
    case PUT_ADMIN_CALENDAR_BOOKING:
      const index = bookings.adminBooking.values.findIndex(value => value.id === payload.id);
      bookings.adminBooking.values[index] = payload;

      return {
        ...bookings,
        ...{
          adminBooking: {
            ...bookings.adminBooking
          }
        }
      }
    case ADD_CALENDAR_EDIT_BOOKING:
      return {
        ...bookings,
        editBooking: payload
      }
    default:
      return bookings;
  }
}

export {bookings};



// WEBPACK FOOTER //
// ./src/reducers/calendar.js